import { render, staticRenderFns } from "./forumSearchResult.vue?vue&type=template&id=68081bb6&scoped=true"
import script from "./forumSearchResult.vue?vue&type=script&lang=js"
export * from "./forumSearchResult.vue?vue&type=script&lang=js"
import style0 from "./forumSearchResult.vue?vue&type=style&index=0&id=68081bb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68081bb6",
  null
  
)

export default component.exports